// Shared content & assets for Saver Plus Lighting Corp.

export const CONTACT = {
  phone: "416-767-0960",
  phoneHref: "tel:+14167670960",
  email: "info@saverpluslighting.com",
  emailHref: "mailto:info@saverpluslighting.com",
  street: "17 Henrietta St",
  city: "Toronto",
  region: "ON",
  postalCode: "M6N 1S4",
  country: "Canada",
  addressFull: "17 Henrietta St, Toronto, ON M6N 1S4",
  mapsHref: "https://www.google.com/maps/search/?api=1&query=17+Henrietta+St+Toronto+ON+M6N+1S4",
  serviceArea: "Toronto & the GTA",
  hours: "Mon – Sun · 7am – 7pm",
  since: "1980",
};

export const IMAGES = {
  heroBuilding:
    "https://images.unsplash.com/photo-1571440727633-ca6b05da2008?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2OTV8MHwxfHNlYXJjaHwzfHxhcmNoaXRlY3R1cmFsJTIwbGlnaHRpbmclMjBidWlsZGluZyUyMG5pZ2h0fGVufDB8fHx8MTc4NTQ2NjE1N3ww&ixlib=rb-4.1.0&q=85",
  facade:
    "https://images.unsplash.com/photo-1480944657103-7fed22359e1d?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2OTV8MHwxfHNlYXJjaHw0fHxhcmNoaXRlY3R1cmFsJTIwbGlnaHRpbmclMjBidWlsZGluZyUyMG5pZ2h0fGVufDB8fHx8MTc4NTQ2NjE1N3ww&ixlib=rb-4.1.0&q=85",
  toronto:
    "https://images.unsplash.com/photo-1698957921407-bf292bcacf5e?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzZ8MHwxfHNlYXJjaHwyfHxUb3JvbnRvJTIwc2t5bGluZSUyMG5pZ2h0JTIwbGlnaHRzfGVufDB8fHx8MTc4NTQ2NjE1N3ww&ixlib=rb-4.1.0&q=85",
  electrician:
    "https://images.unsplash.com/photo-1583275477830-7e8e9d56d15f?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxODl8MHwxfHNlYXJjaHw0fHxlbGVjdHJpY2lhbiUyMGluc3RhbGxpbmclMjBsaWdodCUyMGZpeHR1cmV8ZW58MHx8fHwxNzg1NDY2MTU3fDA&ixlib=rb-4.1.0&q=85",
  electrician2:
    "https://images.unsplash.com/photo-1482731215275-a1f151646268?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxODl8MHwxfHNlYXJjaHwyfHxlbGVjdHJpY2lhbiUyMGluc3RhbGxpbmclMjBsaWdodCUyMGZpeHR1cmV8ZW58MHx8fHwxNzg1NDY2MTU3fDA&ixlib=rb-4.1.0&q=85",
  warehouse:
    "https://images.unsplash.com/photo-1643894440673-553350d13370?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMjd8MHwxfHNlYXJjaHwzfHx3YXJlaG91c2UlMjBsaWdodGluZyUyMGZpeHR1cmVzJTIwcm93c3xlbnwwfHx8fDE3ODU0NjYxNTd8MA&ixlib=rb-4.1.0&q=85",
};

export const FEATURES = [
  {
    title: "Serving Canada Since 1980",
    body: "A trusted, family-operated business built on relationships that span decades.",
  },
  {
    title: "No Minimum Order",
    body: "One item or a full project supply — every order gets the same care, pricing and attention.",
  },
  {
    title: "Wholesale Pricing",
    body: "Competitive pricing for contractors, businesses, municipalities and commercial clients.",
  },
  {
    title: "Professional Installation",
    body: "A team of licensed electricians ready to complete projects of every size and scope.",
  },
  {
    title: "Personalized Service",
    body: "Speak directly with experienced lighting specialists who understand exactly what you need.",
  },
  {
    title: "Extensive Sourcing",
    body: "We source thousands of lighting and electrical products from leading manufacturers.",
  },
];

export const SERVICES = [
  {
    num: "01",
    title: "Wholesale Supply",
    body: "Competitive, transparent wholesale pricing for contractors, businesses, municipalities and commercial developments. No account minimums, no runaround.",
    image: IMAGES.warehouse,
    points: ["Contractor & trade pricing", "Municipal & commercial accounts", "Fast, dependable supply"],
  },
  {
    num: "02",
    title: "Professional Installation",
    body: "Our licensed electricians handle projects of all sizes — from a single fixture swap to a full commercial retrofit — safely and on schedule.",
    image: IMAGES.electrician,
    points: ["Licensed electricians", "Retrofits & new builds", "Projects of every size"],
  },
  {
    num: "03",
    title: "Product Sourcing",
    body: "Can't find it? We can. We source thousands of lighting and electrical products from leading manufacturers to match your spec and budget.",
    image: IMAGES.facade,
    points: ["Thousands of products", "Leading manufacturers", "Spec & budget matching"],
  },
];

export const FOUNDER = {
  name: "Shamin Mohamed Sr.",
  role: "Founder · Visionary · Mentor",
  photo: "/assets/founder.png?v=1",
  dates: "May 11, 1954 — February 17, 2025",
  quote: "Never give up. Always have hope, because hope gives you wings so you can fly.",
  story: [
    "Shamin Mohamed Sr. was the visionary founder whose dream, determination, and entrepreneurial spirit laid the foundation for what is now Saver Plus Lighting Corp. Through hard work, perseverance, and an unwavering commitment to his customers, he built more than a successful business — he built a reputation founded on trust, honesty, and lasting relationships.",
    "Known for his warm smile, welcoming personality, and genuine kindness, Shamin had a remarkable ability to make everyone feel valued. He believed there was always a solution to every challenge and was never afraid to go the extra mile to help someone in need. Whether it was a customer, supplier, friend, or stranger, he was always willing to lend a helping hand.",
    "In the early years, Shamin personally went door to door introducing himself to businesses throughout the Greater Toronto Area. With determination, humility, and a handshake, he built relationships that would last for decades. Many of those first customers became lifelong friends and loyal clients. He believed business wasn't simply about selling products — it was about earning trust, treating people with respect, and standing behind your word.",
    "His work ethic was unmatched, but it was his character that people remembered most. He inspired those around him through his optimism, generosity, perseverance, and unwavering belief that anything was possible with dedication and hard work.",
    "The values he instilled became the foundation of our company and continue to guide every decision we make today. His vision wasn't simply to build a lighting business — it was to build a company that customers could trust, a company where relationships mattered, and where every customer was treated like family.",
    "On February 17, 2025, Shamin sadly passed away following a tragic accident. Although he is deeply missed by his family, friends, customers, and everyone whose life he touched, his legacy continues to shine through the company he built and the countless lives he influenced over more than four decades.",
  ],
  knewHim: [
    "To those who knew him best, he was more than a businessman. He was a devoted father, proud grandfather, mentor, and friend whose generosity, wisdom, and unwavering belief in people left a lasting impression on everyone he met.",
    "Today, our family proudly continues the vision he began by serving every customer with the same integrity, dedication, and personal care that defined his life. Every relationship we build and every customer we serve is a reflection of the values he taught us.",
  ],
  memorial: [
    "In Loving Memory of",
    "Shamin Mohamed Sr.",
    "A visionary whose light continues to guide us every day.",
    "Forever in our hearts.",
  ],
};

export const WEEKLY_DEALS = {
  updated: "Updated weekly · Prices while quantities last",
  note: "Pricing and availability are subject to change. Contact Saver Plus Lighting to confirm current pricing and stock. While quantities last.",
  deals: [
    {
      name: '4" LED Recessed Pot Light (Selectable CCT)',
      category: "LED Lighting",
      ourPrice: 9,
      compPrice: 16,
      competitor: "Retail",
    },
    {
      name: "4ft LED Shop Light · 40W Linkable",
      category: "LED Lighting",
      ourPrice: 22,
      compPrice: 35,
      competitor: "Home Depot",
    },
    {
      name: "LED Rope Light · 50ft Warm White",
      category: "Specialty Lighting",
      ourPrice: 34,
      compPrice: 55,
      competitor: "Retail",
    },
  ],
};

export const OUR_STORY = {
  intro:
    "Every successful business has a beginning, and ours started with a simple belief: treat every customer with honesty, provide quality products, and build relationships that last.",
  paragraphs: [
    "In 1980, Shamin Mohamed Sr. and Salema Mohamed founded S & S Super Light with a shared vision of building a family business rooted in honesty, hard work, and exceptional customer service. Together, they established the foundation of the company and built a reputation for quality products, dependable service, and lasting customer relationships.",
    "As the years went on, Shamin Mohamed Sr. continued to lead and grow the business, dedicating himself to strengthening customer relationships and expanding the company's presence throughout the Greater Toronto Area. His passion, determination, and commitment became the driving force behind the company's continued success and the legacy that lives on today.",
    "As the lighting industry evolved, so did we. New technologies, energy-efficient products, and changing customer needs inspired us to expand our vision while staying true to the values that built our reputation. This led to the creation of Saver Plus Lighting Corp.",
    "Today, Saver Plus Lighting Corp. proudly continues that legacy as a 100% family-operated wholesale lighting supplier. We specialize in providing high-quality lighting solutions for commercial, industrial, retail, institutional, and residential projects across Canada.",
    "What sets us apart is our commitment to service. We believe every customer deserves the same attention, whether they're purchasing a single case of lamps or outfitting an entire facility. We have no minimum order requirements, making it easy for businesses of every size to receive the products and support they need.",
    "Over the years, our product offerings have expanded to include energy-efficient LED lighting, traditional lamps, specialty lighting products, electrical supplies, and custom sourcing solutions. We also proudly offer professional installation services through our team of licensed electricians, giving our customers the convenience of both product supply and expert installation under one trusted company.",
    "As our business has grown and evolved over the years, one thing has remained constant — our commitment to providing dependable products, honest advice, competitive pricing, and exceptional customer service.",
  ],
};

export const MISSION = {
  statement:
    "To provide dependable products, honest advice, competitive pricing, and outstanding customer service while building lasting relationships with every customer we serve.",
  closing:
    "For more than 45 years, our family has proudly served businesses across Canada with integrity, reliability, and a commitment to putting our customers first. We look forward to continuing this tradition by delivering quality lighting solutions, expert service, and trusted partnerships for many years to come.",
};

export const STATS = [
  { value: "45+", label: "Years serving Canada" },
  { value: "100%", label: "Family owned & run" },
  { value: "0", label: "Minimum order" },
  { value: "1000s", label: "Products sourced" },
];

export const PRODUCT_CATEGORIES = [
  {
    num: "01",
    title: "LED Tubes",
    body: "T8, T12, 8-ft LED tubes, ballast-bypass options and replacement solutions.",
    image:
      "https://images.unsplash.com/photo-1632815804501-c43dfd1a4578?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NTJ8MHwxfHNlYXJjaHwzfHxMRUQlMjB0dWJlJTIwbGlnaHRzJTIwZmx1b3Jlc2NlbnQlMjBmaXh0dXJlc3xlbnwwfHx8fDE3ODY1ODc0ODV8MA&ixlib=rb-4.1.0&q=85",
    alt: "Rows of LED tube light fixtures on a ceiling",
  },
  {
    num: "02",
    title: "LED & General-Purpose Bulbs",
    body: "A19, A21 and other commonly used commercial and general-purpose lamps.",
    image:
      "https://images.unsplash.com/photo-1752625447989-238a9c9dbc70?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1MTN8MHwxfHNlYXJjaHwzfHxMRUQlMjBsaWdodCUyMGJ1bGJzJTIwY2xvc2UlMjB1cHxlbnwwfHx8fDE3ODY1ODc0ODV8MA&ixlib=rb-4.1.0&q=85",
    alt: "Close-up of an LED light bulb",
    tags: ["A19", "A21", "candelabra", "globe", "3-way"],
  },
  {
    num: "03",
    title: "GU10 & MR16",
    body: "LED and specialty GU10 and MR16 lamps for accent, track and recessed lighting.",
    image:
      "https://images.unsplash.com/photo-1673699012314-85c304c84b5f?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1MTN8MHwxfHNlYXJjaHwzfHxyZWNlc3NlZCUyMGNlaWxpbmclMjBzcG90bGlnaHRzJTIwdHJhY2slMjBsaWdodGluZ3xlbnwwfHx8fDE3ODY1ODc0ODV8MA&ixlib=rb-4.1.0&q=85",
    alt: "Track-mounted spotlights on a ceiling",
  },
  {
    num: "04",
    title: "PAR Lamps",
    body: "PAR30, PAR38 and specialty PAR lamps for commercial, retail and architectural applications.",
    image:
      "https://images.unsplash.com/photo-1636891852883-862c06a10c90?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA3MDR8MHwxfHNlYXJjaHwzfHxyZXRhaWwlMjBhY2NlbnQlMjBzcG90bGlnaHQlMjBsaWdodGluZ3xlbnwwfHx8fDE3ODY1ODc0ODV8MA&ixlib=rb-4.1.0&q=85",
    alt: "Warm accent spotlight casting a glow on a wall",
    tags: ["PAR20", "PAR30", "PAR38", "flood", "spot"],
  },
  {
    num: "05",
    title: "Commercial & Industrial Lighting",
    body: "Lighting solutions for warehouses, offices, retail environments, facilities and other commercial applications.",
    image: IMAGES.warehouse,
    alt: "Industrial warehouse lit by rows of fixtures",
    tags: ["high-bay", "troffers", "wraps", "shop lights", "panels"],
  },
  {
    num: "06",
    title: "Rope & Decorative Lighting",
    body: "Long-length rope lighting and specialty decorative lighting applications.",
    image:
      "https://images.unsplash.com/photo-1618403323851-ac3d38029495?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAxODF8MHwxfHNlYXJjaHwxfHxMRUQlMjByb3BlJTIwc3RyaW5nJTIwbGlnaHRzJTIwZGVjb3JhdGl2ZXxlbnwwfHx8fDE3ODY1ODc0OTl8MA&ixlib=rb-4.1.0&q=85",
    alt: "Coiled LED rope lighting glowing in the dark",
    tags: ["rope light", "strip", "string", "accent", "warm white"],
  },
  {
    num: "07",
    title: "Specialty & Hard-to-Find Lighting",
    body: "Older lamp styles, unusual sizes and specialty lighting products that may be difficult to source through conventional retailers.",
    image:
      "https://images.unsplash.com/photo-1507494924047-60b8ee826ca9?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NzV8MHwxfHNlYXJjaHwxfHx2aW50YWdlJTIwZWRpc29uJTIwZmlsYW1lbnQlMjBidWxicyUyMGNvbGxlY3Rpb258ZW58MHx8fHwxNzg2NTg3NDk5fDA&ixlib=rb-4.1.0&q=85",
    alt: "A collection of specialty filament bulbs",
    tags: ["discontinued", "odd sizes", "vintage", "projector", "appliance"],
  },
  {
    num: "08",
    title: "Retrofit & Replacement Solutions",
    body: "LED alternatives and retrofit options designed to replace older lighting technologies.",
    image:
      "https://images.unsplash.com/photo-1690240360920-54ce04d1ff1b?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMjh8MHwxfHNlYXJjaHwzfHxlbGVjdHJpY2lhbiUyMGluc3RhbGxpbmclMjBjZWlsaW5nJTIwTEVEJTIwcGFuZWx8ZW58MHx8fHwxNzg2NTg3NTAwfDA&ixlib=rb-4.1.0&q=85",
    alt: "Technician retrofitting a ceiling light fixture",
    tags: ["retrofit kits", "adapters", "conversions", "drivers"],
  },
  {
    num: "09",
    title: "Emergency & Exit Lighting",
    body: "Exit signs, running-man exit lighting and emergency battery units for commercial and institutional buildings.",
    image:
      "https://images.unsplash.com/photo-1561715608-5659baeccfb4?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Njl8MHwxfHNlYXJjaHwxfHxlbWVyZ2VuY3klMjBleGl0JTIwc2lnbiUyMGxpZ2h0fGVufDB8fHx8MTc4ODYyNDk3NXww&ixlib=rb-4.1.0&q=85",
    alt: "Illuminated green running-man emergency exit sign",
    tags: ["exit signs", "running man", "battery units", "combo units", "remote heads"],
  },
  {
    num: "10",
    title: "Fire Alarm Products",
    body: "Pull stations, horns, strobes, smoke and heat detectors, bells and fire alarm accessories.",
    image:
      "https://images.unsplash.com/photo-1653353436174-a8e724190fd3?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzOTB8MHwxfHNlYXJjaHwxfHxyZWQlMjBmaXJlJTIwYWxhcm0lMjBiZWxsJTIwc3Ryb2JlfGVufDB8fHx8MTc4ODYyNDk4NXww&ixlib=rb-4.1.0&q=85",
    alt: "Red fire alarm pull station on a wall",
    tags: ["pull stations", "horns & strobes", "smoke detectors", "heat detectors", "bells"],
  },
];

export const PRODUCT_CREDIBILITY = [
  "Serving businesses since 1980",
  "No minimum order",
  "Commercial & industrial solutions",
  "Specialty sourcing",
  "Installation available",
];
